import React, { useContext } from 'react'
import 'styles/contentBlock.scss'
import { ModalContext } from 'providers/Modal'

const Block = ({ size = '4', blockName, cta, heading, onClick }) => {
  return (
    <div className={`col-sm-${size} text-center`}>
      <a
        id={`${blockName}_icon`}
        href="javascript:void(0)"
        className={`${blockName}`}
        onClick={onClick}
      >
        <span />
      </a>
      <div className="special_someone_wrap">
        <a
          id={`${blockName}_link`}
          className="link"
          href="javascript:void(0)"
          onClick={onClick}
        >
          {heading}
        </a>
        <div>{cta}</div>
      </div>
    </div>
  )
}

function ContentBlock(props) {
  const { setActive } = useContext(ModalContext)

  return (
    <div className="container">
      <h2 className="text-center find_someone">Find your Special Someone</h2>
      <div className="row">
        <Block
          blockName="sign_up"
          heading="Sign Up"
          cta="Register for free &amp; put up your Profile"
          onClick={() => setActive('register')}
        />
        <Block
          blockName="connect"
          heading="Connect"
          cta="Select &amp; Connect with Matches you like"
          onClick={() => setActive('register')}
        />
        <Block
          blockName="interact"
          heading="Interact"
          cta="Become a Premium Member &amp; Start a Conversation"
          onClick={() => setActive('register')}
        />
      </div>
    </div>
  )
}

export default ContentBlock
